export default "__VITE_ASSET__C6jxEE$d__"